import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router';
import { connect } from 'react-redux';
import { Text } from '@omilia/typography';
import { AlertMessage } from '@omilia/alert';
import { ToastContainer, toast } from 'react-toastify';

import { removeState as removeLocalStorageState } from 'store/utils/localStorage';
import { removeState as removeSessionStorageState } from 'store/utils/sessionStorage';
import { KeycloakActionsContext } from 'hooks/useKeycloak';
import { pairAccount } from 'store/services/session/actions';
import omiliaLogo from 'styles/images/Omilia-Logo-notext.svg';
import {
  SForm,
  SInner,
  SExtraInfoText,
  SExtraInfo,
  SAlertBox,
  SFooterText,
  SLayout,
  STitle,
} from './styled';
import VerifyForm from './components/VerifyForm';

const year = new Date().getFullYear();

type DispatchProps = {
  pairAccount: (props: {
    email: string;
    password: string;
    keycloak_token: string | null;
  }) => void;
};

const VerifyAccount = ({ pairAccount }: DispatchProps) => {
  const history = useHistory();
  const { token, logout } = useContext(KeycloakActionsContext);

  const handlePairAccount = async ({
    email,
    password,
  }: {
    email: string;
    password: string;
  }) => {
    await pairAccount({ email, password, keycloak_token: token });
    history.push('/');
  };

  const handleLogout = () => {
    removeLocalStorageState();
    removeSessionStorageState();
    logout({ redirectUri: process.env.KEYCLOAK_REDIRECT_URI_AFTER_LOGOUT });
  };

  return (
    <SLayout>
      <Helmet>
        <title>Verify your account</title>
      </Helmet>

      <ToastContainer
        hideProgressBar
        newestOnTop
        autoClose={10000}
        closeButton={false}
        draggable={false}
        position={toast.POSITION.TOP_RIGHT}
      />

      <section>
        <img alt="Conversation Studio logo" src={omiliaLogo} />
      </section>
      <SInner>
        <SForm>
          <STitle data-test="verify-account-form-title">
            Verify your account
          </STitle>
          <SAlertBox>
            <AlertMessage variant="critical">
              In order to enable SSO authentication you must first verify your
              Conversation Studio account
            </AlertMessage>
          </SAlertBox>
          <VerifyForm onSubmit={handlePairAccount} />
        </SForm>
        <SExtraInfo>
          <Text level={4}>Forgot your credentials?</Text>
          <button
            data-test="logout-button"
            type="button"
            onClick={handleLogout}
          >
            <SExtraInfoText level={4}>Back to login</SExtraInfoText>
          </button>
        </SExtraInfo>
      </SInner>

      <div>
        <SFooterText level={4}>
          Copyright &copy; {year} Omilia Ltd. All Rights Reserved.
        </SFooterText>
      </div>
    </SLayout>
  );
};

export default connect(null, { pairAccount })(VerifyAccount);
